import React, { useState, useEffect } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Navbar from '../components/Navbar';
import { useLanguage } from '../context/language';
import { useHistory } from 'react-router-dom';
import { getStrLang } from '../components/Translate';
import PicPayLogo from '../assets/picpay-logo.png'
import StripeCC from '../components/Abas/StripeCC';
import PicPay from '../components/Abas/PicPay'
import GooglePay from '../components/Abas/GooglePay'
import Ted from '../components/Abas/Ted';
import GACC from '../components/Abas/GACC'
import OfaPay from '../components/Abas/OfaPay'
import LPCC from '../components/Abas/LPCC'
import LPDC from '../components/Abas/LPDC'
import LPCASH from '../components/Abas/LPCASH'
// import SPEI from '../components/Abas/SPEI'
import SEPA from '../components/Abas/SEPA'
import Boleto from '../components/Abas/Boleto';
import Pix from '../components/Abas/Pix';
import USDtPIX from '../components/Abas/USDtPIX';
import Crypto from '../components/Abas/Crypto'
import ReturnInfo from '../components/ReturnInfo';
import AbaTitulo from '../components/Abas/AbaTitulo';
import PayCash from '../components/Abas/PayCash'
import MonnetPayment from '../components/Abas/MonnetPayment'
import ProntoPaga from '../components/Abas/ProntoPaga'
import MorePayment from '../components/Abas/MorePayment'
import PaykuPayment from '../components/Abas/Payku'
import Mids88 from '../components/Abas/Mids88'
import Rixsus from '../components/Abas/Rixsus'
import StarPago from '../components/Abas/Starpago'
import SimplyPay from '../components/Abas/SimplyPay'
import Cobre from '../components/Abas/Cobre'
import PayokPayment from '../components/Abas/Payok'
import SauriPay from '../components/Abas/SauriPay'

import TedIcon from '../assets/ted_icon.png';
import BoletoIcon from '../assets/boleto_icon.png';
import CryptoIcon from '../assets/crypto_icon.png';
import BankIcon from '../assets/bank.png'
import PixIcon from '../assets/pix_icon.png';
import CreditCardIcon from '../assets/credit_card.png';
import SepaIcon from '../assets/sepa-2.svg'
import DebitCardIcon from '../assets/debit_card.png'
import CashIcon from '../assets/money.png';
import SpeiIcon from '../assets/spei.jpg'
import GooglePayIcon from '../assets/google-pay.png'
import PayCashIcon from '../assets/pay_cash.png'

import mercadopagoqr_payment from '../assets/mercadopagoqr_payment.jpeg'
import mach_payment from '../assets/mach_payment.png'
import etpay_payment from '../assets/etpay_payment.png'
import webpay_payment from '../assets/webpay_payment.png'
import niubiz_payment from '../assets/niubiz_payment.jpeg'
import prometeo_payment from '../assets/prometeo_payment.png'
import pagoefectivo_payment from '../assets/pagoefectivo_payment.png'
import payphone_payment from '../assets/payphone_payment.png'
import pagoefectivo_ecu_payment from '../assets/pagoefectivo_ecu_payment.png'

import Footer from '../components/Footer';
import $ from 'jquery';
import { sendEmail, setAceiteTermos, getAceiteTermos } from '../api/fastcoinService';
import { ModalTermos } from '../components/ModalTermos';
import { AppletTermos } from '../components/AppletTermos';
import Loading from '../assets/loading.gif';
import PSE from '../components/Abas/PSE';
import Efecty from '../components/Abas/Efecty';
import Wallet from '../components/Abas/Wallet';
import PseIcon from '../assets/pse_icon.png';
import EfectyIcon from '../assets/efecty_icon.png';
import WalletIcon from '../assets/wallet_icon.png';
import { getDeposit } from '../api/fastcoinService';
import { getURLBackToPanel } from '../context/brokersUrl';
import pay_id from '../assets/pay_id.png'
import mobile_money from '../assets/mobile_money.jpg'
import wallets from '../assets/wallets.png'
import virtual_account from '../assets/virtual_account.png'
import debit_card from '../assets/debit_card.png'
import papara from '../assets/papara.webp'
import payfix from '../assets/payfix.png'
import atm from '../assets/atm.jpg'
import momopay from '../assets/momopay.png'
import qr_code from '../assets/qr_code.jpg'
import g_pay from '../assets/g_pay.png'
import pay_tm from '../assets/pay_tm.png'
import phone_pe from '../assets/phone_pe.png'
import upi from '../assets/upi.webp'
import bank_transfer from '../assets/bank.png'

import pagofacil from '../assets/pagofacil.png'
import rapipago from '../assets/rapipago.png'
import UsdtLogo from '../assets/usdt.png'

import Alipay2alipay from '../assets/Alipay2alipay.png';
import P2P from '../assets/p2p.jpg';
import P2P_Manual from '../assets/P2P_Manual.jpg';
import DinTalk from '../assets/DinTalk.png';
import ECNY from '../assets/ECNY.svg';
import VA from '../assets/VA.png';
import OB from '../assets/OB.png';
import MOMO from '../assets/MOMO.jpg';
import Viettelpay from '../assets/Viettelpay.png';
import P2C from '../assets/p2c.png';
import Zalo from '../assets/Zalo.png';
import Duitnow from '../assets/Duitnow.png';
import VABCA from '../assets/VABCA.jpg';
import QRIS from '../assets/QRIS.png';
import Gcash_Original from '../assets/Gcash_Original.png';
import MAYA_Original from '../assets/MAYA_Original.jpg';
import Gcash from '../assets/Gcash.png';
import Maya from '../assets/Maya.jpg';
import QRPHP from '../assets/QRPHP.webp';
import GrabPay from '../assets/GrabPay.png';
import OFA_UPI from '../assets/upi.webp';
import QR from '../assets/QR.jpg';
import TrueMoney from '../assets/TrueMoney.png';

import servifacil_payment from '../assets/servifacil_payment.png'
import PayWithYourBank from '../assets/bank.png'
import marketpaymentqr_payment from '../assets/marketpaymentqr_payment.png'
import broadnet_payment from '../assets/broadnet_payment.png'
import bemovil_payment from '../assets/bemovil_payment.png'
import redactiva_payment from '../assets/redactiva_payment.png'
import deuna_payment from '../assets/deuna_payment.png'

import red_pagos from '../assets/red_pagos.png'
import provincia_net from '../assets/provincia_net.png'
import newpay from '../assets/newpay.webp'
import b89 from '../assets/b89.png'
import cobre from '../assets/cobre.png'
import treviso from '../assets/treviso.png'

import khipu_payku from '../assets/khipu_payku.svg'
import multicaja_efectivo_payku from  '../assets/khipu_payku.svg'
import safety_payku from '../assets/safety_payku.png';
import fintoc_payku from '../assets/fintoc_payku.webp';
import fpay_payku from '../assets/fpay_payku.png';
import cybersource_payku from '../assets/cybersource_payku.png';
import chek_payku from '../assets/chek_payku.jpg';
import hites_payku from '../assets/hites_payku.webp';
import cleo_payku from '../assets/cleo_payku.webp';
import pago46_payku from '../assets/pago46_payku.png';
import onepay_payku from '../assets/onepay_payku.webp';
import SimplyPayIcon from '../assets/simplypay.jpeg'
import CobreIcon from '../assets/cobre_co.png'
import payokMethods from '../util/payokMethods';

const prontopaga=["mercadopagoqr_payment","mach_payment","etpay_payment","webpay_payment","niubiz_payment","prometeo_payment","pagoefectivo_payment","payphone_payment","pagoefectivo_ecu_payment",
    "servifacil_payment","PayWithYourBank","marketpaymentqr_payment","broadnet_payment","bemovil_payment","redactiva_payment","deuna_payment"
]

const morepayment=["treviso","stp","red_pagos","provincia_net","prometeo","newpay","b89"]

const paykupayment = [
    "webpay_payment_payku",
    "khipu_payku",
    "multicaja_efectivo_payku",
    "etpay_payment_payku",
    "onepay_payku",
    "pago46_payku",
    "cleo_payku",
    "hites_payku",
    "mach_payment_payku",
    "chek_payku",
    "cybersource_payku",
    "transaccion_completa_payku",
    "servifacil_payment_payku",
    "vepuy_payku",
    "klap_payku",
    "fintoc_payku",
    "safety_payku"
]


const mids88=[
    "pay_id",
    "bank_transfer",
    "mobile_money",
    "wallets",
    "virtual_account",
    "debit_card",
    "papara",
    "payfix",
    "atm",
    "momopay",
    "qr_code",
    "g_pay",
    "pay_tm",
    "phone_pe",
    "upi"
]

const payok_methods=Object.keys(payokMethods).map((key)=>key.toLowerCase())

const rixsus_method=["pagofacil","rapipago"]

const ofapay_method=["Alipay2alipay", "P2P", "P2P_Manual", "DinTalk", "ECNY", "VA", "OB", "MOMO", "Viettelpay", "P2C", "Zalo", "Duitnow", "VABCA", "QRIS","Gcash_Original","MAYA_Original", "Gcash", "Maya", "QRPHP", "GrabPay", "OFA_UPI", "QR", "TrueMoney"]

const ofapay_icon = { Alipay2alipay, P2P, P2P_Manual, DinTalk, ECNY, VA, OB, MOMO, Viettelpay, P2C, Zalo, Duitnow, VABCA, QRIS, Gcash_Original, MAYA_Original, Gcash, Maya, QRPHP, GrabPay, OFA_UPI, QR, TrueMoney };

const icon={
    mercadopagoqr_payment,mach_payment,etpay_payment,webpay_payment,niubiz_payment,prometeo_payment,pagoefectivo_payment,payphone_payment,pagoefectivo_ecu_payment,
    servifacil_payment,PayWithYourBank,marketpaymentqr_payment,broadnet_payment,bemovil_payment,redactiva_payment,deuna_payment
}
const midsicon={
    pay_id,bank_transfer,mobile_money,wallets,virtual_account,debit_card,papara,payfix,atm,momopay,qr_code,g_pay,pay_tm,phone_pe,upi
}
const rixsusicon={
    pagofacil,rapipago
}
const morepayment_icon={treviso,stp:SpeiIcon,red_pagos,provincia_net,prometeo:prometeo_payment,newpay,cobre,b89}

const paykupayment_icon={webpay_payment_payku:webpay_payment,khipu_payku,etpay_payment_payku:etpay_payment,mach_payment_payku:mach_payment,servifacil_payment_payku:servifacil_payment,etpay_payment_payku:etpay_payment,
    multicaja_efectivo_payku,safety_payku,fintoc_payku,fpay_payku,cybersource_payku,chek_payku,hites_payku,cleo_payku,pago46_payku,onepay_payku,transaccion_completa_payku:bank_transfer,vepuy_payku:bank_transfer,
    klap_payku:bank_transfer,
}

const spanish_speaking_countries = [
    "ar", "bo", "co", "cr", "cl", "do", "ec", "mx", "pa", "pe", "py", "uy", "gt", "hn","sv"
];

const DepositScreen = () => {
    const history = useHistory();
    const { lang, orderFromDeposit, translate, setLang, optionsLang } = useLanguage();
    const [modal, setModal] = useState(false);
    const [termos, setTermos] = useState(false);
    const [showTermos, setShowTermos] = useState(true);
    const [allowEmail, setAllowEmail] = useState(false);
    const [doc, setDoc] = useState(false);
    const [loadingCheckterms, setLoadingCheckterms] = useState(true);
    const [opt_payment, setOpt_payment] = useState();
    const [pg_payment, setPg_payment] = useState();
    //mudar layout da tela por país de origem da ordem.
    const [container, setContainer] = useState("container");
    const [containerMain, setContainerMain] = useState("container-main boxes");
    const [containerSecondary, setContainerSecondary] = useState("container-secondary boxes");
    // const [infoDepositValueH3, setInfoDepositValueH3] = useState("info-deposit-value h3");
  

    const [clientName, setClientName] = useState("");
    const [client_logo,set_client_logo]=useState("")
    const [is_white_label,set_is_white_label]=useState(false)
    const [methodList,setMethodList]=useState([])
    const [currentMethod,setCurrentMethod]=useState("")
    const [methodListForRank,setMethodListForRank]=useState([])
    
    useEffect(() => {
        let country = sessionStorage.getItem("country");
        let broker = sessionStorage.getItem("broker");
        let order_no = sessionStorage.getItem("order_no");
        if (country === null || broker === null || order_no === null || country.length === 0 || broker.length === 0 || order_no.length === 0) {
            return (
                <>
                    {history.push("/404", { country: country, broker: broker, order_no: order_no, from: history.location.pathname })}
                </>
            )
        } else {
            tiposPagamento();
            if (country.toLowerCase() === 'co') {
                setContainer("container-co");
                setContainerMain("container-main-co boxes");
                setContainerSecondary("container-secondary-co boxes");
                // setInfoDepositValueH3("info-deposit-value-co h3");
            };
        }
    }, []);

    function toggle() {
        setModal(!modal);
    }

    const tiposPagamento = () => {
        getDeposit(sessionStorage.getItem("order_no"))
            .then((res) => {
                if(res.clientData!==null){
                    if(res.clientData?.is_white_label){
                        if(res.clientData?.client_logo){
                            sessionStorage.setItem('is_white_label',"true");
                            sessionStorage.setItem('client_logo',res.clientData?.client_logo);
                            set_client_logo(res.clientData?.client_logo)
                            set_is_white_label(true)
                        }else{
                            set_client_logo("")
                            sessionStorage.setItem('is_white_label',"true");
                        }
 
                    }else{
                        sessionStorage.setItem('is_white_label',"false");
                        set_client_logo("payeasy")
                    }
                }else{
                    set_client_logo("payeasy")
                    sessionStorage.setItem('is_white_label',"false");
                }

                
                setClientName(res.client_title);
                sessionStorage.setItem('client_name', res.client_title);
                sessionStorage.setItem('full_address', res.full_address);
                let arrayPayments = res.paymentMethods;
                let tipoPayment = arrayPayments.map((arrayPayments) => arrayPayments.type_payment)
                sessionStorage.setItem("bank_info", JSON.stringify(res.paymentMethods.filter(item => item.description === "TED")))
                sessionStorage.setItem("bank_info_sepa", JSON.stringify(res.paymentMethods.filter(item => item.description === "SEPA")))

                const isThereUsdtPix=tipoPayment.find((f)=>f=='USDtPIX')
                if(isThereUsdtPix){
                    tipoPayment = tipoPayment.filter((f) => f !== "CRYPTO" && f !== "PIX");               
                }

                setMethodListForRank([...new Set(tipoPayment)])               
            })
            .catch((err) => {
                console.log(err);
            })
    }


    useEffect(() => {
        getURLBackToPanel();
        if (orderFromDeposit !== "") {
            validarTermos();
            aba_payment();
            if (spanish_speaking_countries.includes(orderFromDeposit)) {
                setLang(optionsLang[2]);
                translate(optionsLang[2].nameLang);
            } else if (orderFromDeposit === "br") {
                setLang(optionsLang[0]);
                translate(optionsLang[0].nameLang);
            } else {
                setLang(optionsLang[1]);
                translate(optionsLang[1].nameLang);
            }
        }
    }, [orderFromDeposit,methodListForRank]);

    useEffect(() => {
        if (allowEmail === true && sessionStorage.getItem("order_no") !== null && termos === true) {
            setLoadingCheckterms(true);
            callSendEmail();
            setAllowEmail(false);
            setTermos(false);
        }
    }, [allowEmail, termos]);

    useEffect(() => {
        translate();
    }, [modal, translate, showTermos, loadingCheckterms]);

    useEffect(() => {
        aba_payment();
    }, [translate]);

    const aceitetermos = (confirm = null) => {
        setTermos(!termos);
        if (confirm === true && doc === true) {
            sessionStorage.setItem("documento_cliente", document.getElementsByName("docNumber").item(0).value);
            toggle();
            setAllowEmail(true);
        }
    }

    const mostrarInformacoesPgto = () => {
        if (termos && doc) {
            sessionStorage.setItem("documento_cliente", document.getElementsByName("docNumber").item(0).value);
            setAllowEmail(true);
        }
    }

    const changeDoc = (state) => {
        setDoc(state);
    }

    async function callSendEmail() {
        //Essa função do cloudflare é usa para pegar o IP do usuário e poder enviar junto com o e-mail de aceite de termos
        let ipNumber;
        await $.get('https://www.cloudflare.com/cdn-cgi/trace', function (data) {
            data = data.trim().split('\n').reduce(function (obj, pair) {
                pair = pair.split('=');
                return obj[pair[0]] = pair[1], obj;
            }, {});
            ipNumber = data.ip;
            let objData = {};
            objData.to = "termos@payeasy.tech";
            objData.subject = `Order ${sessionStorage.getItem("order_no")} - deposit - Accepted terms`;
            objData.text = `<b>Os termos foram aceitos para o depósito!</b><br/><b>Origem: </b>${ipNumber}<br/><b>Data: </b>${new Date()}<br/><b>Nome: </b>${sessionStorage.getItem("full_Name")}<br/><b>E-mail: </b>${sessionStorage.getItem("email")}<br/><b>CPF/CNPJ: </b>${sessionStorage.getItem("documento_cliente")}`;
            //console.log(objData.text);
            sendEmail(objData);
        });
        sessionStorage.setItem("ipNumber",ipNumber)

        setAceiteTermos(sessionStorage.getItem("order_no"), sessionStorage.getItem("documento_cliente"), ipNumber)
            .finally(() => {
                validarTermos();
            })
    }

    function validarTermos() {
        getAceiteTermos(sessionStorage.getItem("order_no"))
            .then(res => {
                //console.log(res);
                if (res !== undefined) {
                    setShowTermos(false);
                } else {
                    setShowTermos(true);
                }
            })
            .catch(err => {                
                if (err.error.includes("Could not find")) {
                    console.log(err);
                } else {
                    console.log(err);
                    alert("Please talk with the administrator");
                }
                setShowTermos(true);
            })
            .finally(() => {
                setLoadingCheckterms(false);
            })
    }

    //Indentificar a origem da ordem para definir quais opções de pagmento.
    function aba_payment() {
        let opt=[],pg=[],method_list=[]

        let usdtprovider="cointspayment"
        let CRYPTO_NOW=methodListForRank.find((m)=>m==="CRYPTO_NOW")
        if(CRYPTO_NOW){
            usdtprovider="crypto_now"
        }

        let CRYPTOPAYX=methodListForRank.find((m)=>m==="cryptopayx")
        if(CRYPTOPAYX){
            usdtprovider="cryptopayx"
        }

        for(const methd of methodListForRank){
            const method=methd.toLowerCase()
            if (method === "pix") {
                opt.push(<Tab><AbaTitulo texto={"PIX"} src={PixIcon} alt={"Imagem da aba TED"} className={"titulo-aba"} /></Tab>)
                pg.push(<Pix setShowTermos={setShowTermos} pix_time_limit={sessionStorage.getItem("pix_time_limit")}/>)
                method_list.push("pix")
            }
            if (method === "ted") {
                opt.push(<Tab><AbaTitulo texto={getStrLang(lang.nameLang, "transf_bank")} src={TedIcon} alt={"Imagem da aba TED"} className={"titulo-aba"} /></Tab>)
                pg.push(<Ted setShowTermos={setShowTermos} />)
                method_list.push("ted")
            }
            if (method === "boleto") {
                opt.push(<Tab><AbaTitulo texto={getStrLang(lang.nameLang, "boleto_bank")} src={BoletoIcon} alt={"Imagem da aba TED"} className={"titulo-aba"} /></Tab>)
                pg.push(<Boleto setShowTermos={setShowTermos} />)
                method_list.push("boleto")
            }
            if (method === "efecty") {
                opt.push(<Tab><AbaTitulo texto={"Efecty"} src={EfectyIcon} alt={"Imagem da aba TED"} className={"titulo-aba-lg"} /></Tab>)
                pg.push(<Efecty setShowTermos={setShowTermos} />)
                method_list.push("efecty")
            }
            if (method === "ewallet") {
                opt.push(<Tab><AbaTitulo texto={"E-wallet"} src={WalletIcon} alt={"Imagem da aba TED"} className={"titulo-aba-lg"} /></Tab>)
                pg.push(<Wallet setShowTermos={setShowTermos} />)
                method_list.push("e-wallet")
            }
            if (method === "pse") {
                opt.push(<Tab><AbaTitulo texto={"PSE"} src={PseIcon} alt={"Imagem da aba TED"} className={"titulo-aba-lg"} /></Tab>)
                pg.push(<PSE setShowTermos={setShowTermos} />)
                method_list.push("pse")
            }
            if (method === "crypto") {
                opt.push(<Tab><AbaTitulo texto={getStrLang(lang.nameLang, "crypto")} src={CryptoIcon} alt={"Imagem da aba Crypto"} className={"titulo-aba"} /></Tab>)
                pg.push(<Crypto setShowTermos={setShowTermos} provider='cointspayment'/>)
                method_list.push("crypto")
            }
            if (method === "crypto_now") {
                opt.push(<Tab><AbaTitulo texto={getStrLang(lang.nameLang, "crypto")} src={CryptoIcon} alt={"Imagem da aba Crypto"} className={"titulo-aba"} /></Tab>)
                pg.push(<Crypto setShowTermos={setShowTermos} provider={'crypto_now'}/>)
                method_list.push("crypto")
            }
            if (method === "cryptopayx") {
                opt.push(<Tab><AbaTitulo texto={getStrLang(lang.nameLang, "crypto")} src={CryptoIcon} alt={"Imagem da aba Crypto"} className={"titulo-aba"} /></Tab>)
                pg.push(<Crypto setShowTermos={setShowTermos} provider={'cryptopayx'}/>)
                method_list.push("crypto")
            }
            // if (method === "bank_transfer") {
            //     opt.push(<Tab><AbaTitulo texto={getStrLang(lang.nameLang, "bank_transfer")} src={BankIcon} alt={"Imagem da aba bank"} className={"titulo-aba"} /></Tab>)
            //     pg.push(<LPBT setShowTermos={setShowTermos} />)
            //     method_list.push("bank")
            // }
            if (method === "lp_cc") {
                opt.push(<Tab><AbaTitulo texto={getStrLang(lang.nameLang, "cc")} src={CreditCardIcon} alt={"Imagem da aba bank"} className={"titulo-aba"} /></Tab>)
                pg.push(<LPCC setShowTermos={setShowTermos} />)
                method_list.push("card")
            }
            if (method === "lp_dc") {
                opt.push(<Tab><AbaTitulo texto={getStrLang(lang.nameLang, "dc")} src={DebitCardIcon} alt={"Imagem da aba bank"} className={"titulo-aba"} /></Tab>)
                pg.push(<LPDC setShowTermos={setShowTermos} />)
                method_list.push("card")
            }
            if (method === "cash") {
                opt.push(<Tab><AbaTitulo texto={getStrLang(lang.nameLang, "cash")} src={CashIcon} alt={"Imagem da aba bank"} className={"titulo-aba"} /></Tab>)
                pg.push(<LPCASH setShowTermos={setShowTermos} />)
                method_list.push("cash")
            }
            if (method === "spei") {
                opt.push(<Tab><AbaTitulo texto={'SPEI'} src={SpeiIcon} alt={"Imagem da aba SPEI"} className={"titulo-aba"} /></Tab>)
                pg.push(<StarPago setShowTermos={setShowTermos} payment_type="SPEI"/>)
                method_list.push("SPEI")
            }
            if (method === "ga_pay") {
                opt.push(<Tab><AbaTitulo texto={''} src={GooglePayIcon} alt={"Imagem da aba GPAY"} className={"titulo-aba"} isGpay={true}/></Tab>)
                pg.push(<GooglePay setShowTermos={setShowTermos} />)
                method_list.push("GApay")
            } 
            if (method === "pic_pay") {
                opt.push(<Tab><AbaTitulo texto={''} src={PicPayLogo} alt={"Imagem da aba PicPay"} className={"titulo-aba"} isGpay={true} /></Tab>)
                pg.push(<PicPay setShowTermos={setShowTermos} />)
                method_list.push("picpay")
            } 
            if (method === "stripe_cc") {
                opt.push(<Tab><AbaTitulo texto={getStrLang(lang.nameLang, "cc")} src={CreditCardIcon} alt={"Imagem da aba bank"} className={"titulo-aba"} /></Tab>)
                pg.push(<StripeCC setShowTermos={setShowTermos} provider_name={'stripe_cc'}/>)
                method_list.push("CCS")
            }
            if (method === "ccx") {
                opt.push(<Tab><AbaTitulo texto={getStrLang(lang.nameLang, "cc")} src={CreditCardIcon} alt={"Imagem da aba bank"} className={"titulo-aba"} /></Tab>)
                pg.push(<StripeCC setShowTermos={setShowTermos} provider_name={'CCX'}/>)
                method_list.push("CCX")
            }
            if (method === "ccp") {
                opt.push(<Tab><AbaTitulo texto={getStrLang(lang.nameLang, "cc")} src={CreditCardIcon} alt={"Imagem da aba bank"} className={"titulo-aba"} /></Tab>)
                pg.push(<StripeCC setShowTermos={setShowTermos} provider_name={'ccp'}/>)
                method_list.push("CCP")
            } 
            if (method === "ccb") {
                opt.push(<Tab><AbaTitulo texto={getStrLang(lang.nameLang, "cc")} src={CreditCardIcon} alt={"Imagem da aba bank"} className={"titulo-aba"} /></Tab>)
                pg.push(<StripeCC setShowTermos={setShowTermos} provider_name={'ccb'}/>)
                method_list.push("CCB")
            } 

            if (method === "sepa") {
                opt.push(<Tab><AbaTitulo texto={''} src={SepaIcon} alt={"Imagem da aba sepa"} className={"titulo-aba"} isGpay={true}/></Tab>)
                pg.push(<SEPA setShowTermos={setShowTermos} />)
                method_list.push("sepa")
            }
            if (method === "ccr") {
                opt.push(<Tab><AbaTitulo texto={getStrLang(lang.nameLang, "cc")} src={CreditCardIcon} alt={"Imagem da aba bank"} className={"titulo-aba"} /></Tab>)
                pg.push(<StripeCC setShowTermos={setShowTermos} provider_name={'ccr'}/>)
                method_list.push("CCR")
            }
            if(method === "pay_cash"){
                opt.push(<Tab><AbaTitulo texto={getStrLang(lang.nameLang, "pay_cash")} src={PayCashIcon} alt={"Imagem da paycash"} className={"titulo-aba"} /></Tab>)
                pg.push(<PayCash setShowTermos={setShowTermos} />)
                method_list.push("pay_cash")
            }
            if(method === "monnet_cash"){
                opt.push(<Tab><AbaTitulo texto={getStrLang(lang.nameLang, "cash")} src={CashIcon} alt={"Imagem da CashIcon"} className={"titulo-aba"} /></Tab>)
                pg.push(<MonnetPayment setShowTermos={setShowTermos} payment_type="monnet_cash"/>)
                method_list.push("monnet_cash")
            }
            if(method === "monnet_bank_transfer"){
                opt.push(<Tab><AbaTitulo texto={getStrLang(lang.nameLang, "bank_transfer")} src={BankIcon} alt={"Imagem da CashIcon"} className={"titulo-aba"} /></Tab>)
                pg.push(<MonnetPayment setShowTermos={setShowTermos} payment_type="monnet_bank_transfer"/>)
                method_list.push("monnet_bank_transfer")
            }
            if(method === "monnet_cc"){
                opt.push(<Tab><AbaTitulo texto={getStrLang(lang.nameLang, "cc")} src={CreditCardIcon} alt={"Imagem da CashIcon"} className={"titulo-aba"} /></Tab>)
                pg.push(<MonnetPayment setShowTermos={setShowTermos} payment_type="monnet_cc"/>)
                method_list.push("monnet_cc")
            }
            if(method === "monnet_dc"){
                opt.push(<Tab><AbaTitulo texto={getStrLang(lang.nameLang, "dc")} src={DebitCardIcon} alt={"Imagem da CashIcon"} className={"titulo-aba"} /></Tab>)
                pg.push(<MonnetPayment setShowTermos={setShowTermos} payment_type="monnet_dc"/>)
                method_list.push("monnet_dc")
            }
            if(method === "monnet_wallet"){
                opt.push(<Tab><AbaTitulo texto={getStrLang(lang.nameLang, "wallet")} src={WalletIcon} alt={"Imagem da CashIcon"} className={"titulo-aba"} /></Tab>)
                pg.push(<MonnetPayment setShowTermos={setShowTermos} payment_type="monnet_wallet"/>)
                method_list.push("monnet_wallet")
            }
            if(method === "usdtpix"){
                opt.push(<Tab><AbaTitulo texto={"USDtPIX"} src={UsdtLogo} alt={"Imagem da aba TED"} className={"titulo-aba"} src2={PixIcon}/></Tab>)
                pg.push(<USDtPIX setShowTermos={setShowTermos} pix_time_limit={sessionStorage.getItem("pix_time_limit")} setCurrentMethod={setCurrentMethod} usdtprovider={usdtprovider} />)
                // method_list.push("usdtpix")
            }
            if(prontopaga.find((p)=>p===method)){
                opt.push(<Tab><AbaTitulo  src={icon[method]} alt={`Imagem da aba ${method}`} className={"titulo-aba"} isGpay={true} /></Tab>)
                pg.push(<ProntoPaga setShowTermos={setShowTermos} payment_type={method}/>)
                method_list.push(method)
            }
            if(mids88.find((p)=>p===method)){
                opt.push(<Tab><AbaTitulo  src={midsicon[method]} alt={`Imagem da aba ${method}`} className={"titulo-aba"} isGpay={true} /></Tab>)
                pg.push(<Mids88 setShowTermos={setShowTermos} payment_type={method}/>)
                method_list.push(method)
            }
            if(rixsus_method.find((p)=>p===method)){
                opt.push(<Tab><AbaTitulo  src={rixsusicon[method]} alt={`Imagem da aba ${method}`} className={"titulo-aba"} isGpay={true} /></Tab>)
                pg.push(<Rixsus setShowTermos={setShowTermos} payment_type={method}/>)
                method_list.push(method)
            }
            if(ofapay_method.find((p)=>p===methd)){
                opt.push(<Tab><AbaTitulo  src={ofapay_icon[methd]} alt={`Imagem da aba ${methd}`} className={"titulo-aba"} isGpay={true} /></Tab>)
                pg.push(<OfaPay setShowTermos={setShowTermos} payment_type={methd}/>)
                method_list.push(methd)
            }
            
            if(method === "gacc"){
                opt.push(<Tab><AbaTitulo texto={''} src={GooglePayIcon} alt={"Imagem da aba GACC pay"} className={"titulo-aba"} isGacc={true}/></Tab>)
                pg.push(<GACC setShowTermos={setShowTermos} payment_type="GACC"/>)
                method_list.push("GACC")
            }
            if(morepayment.find((p)=>p===method)){
                opt.push(<Tab><AbaTitulo  src={morepayment_icon[method]} alt={`Imagem da aba ${method}`} className={"titulo-aba"} isGpay={true} /></Tab>)
                pg.push(<MorePayment setShowTermos={setShowTermos} payment_type={method}/>)
                method_list.push(method)
            }
            if(paykupayment.find((p)=>p===method)){
                opt.push(<Tab><AbaTitulo  src={paykupayment_icon[method]} alt={`Imagem da aba ${method}`} className={"titulo-aba"} isGpay={true} /></Tab>)
                pg.push(<PaykuPayment setShowTermos={setShowTermos} payment_type={method}/>)
                method_list.push(method)
            }
            if (method === "cca") {
                opt.push(<Tab><AbaTitulo texto={getStrLang(lang.nameLang, "cc")} src={CreditCardIcon} alt={"Imagem da aba bank"} className={"titulo-aba"} /></Tab>)
                pg.push(<StripeCC setShowTermos={setShowTermos} provider_name={'CCA'} />)
                method_list.push("CCA")
            }
            if(method === "simplypay"){
                opt.push(<Tab><AbaTitulo src={SimplyPayIcon} alt={"Imagem da simplypay"} className={"titulo-aba"} isGpay={true}/></Tab>)
                pg.push(<SimplyPay setShowTermos={setShowTermos} />)
                method_list.push("simplypay")
            }

            if(method === "cobre"){
                opt.push(<Tab><AbaTitulo texto={''} src={CobreIcon} alt={"Imagem da aba Cobre"} className={"titulo-aba"} isGacc={true}/></Tab>)
                pg.push(<Cobre setShowTermos={setShowTermos} />)
                method_list.push("cobre")
            }
            if (method === "spei_cobre") {
                opt.push(<Tab><AbaTitulo texto={''} src={SpeiIcon} alt={"Imagem da aba Cobre"} className={"titulo-aba"} isGacc={true} /></Tab>)
                pg.push(<Cobre setShowTermos={setShowTermos} payment_type={"spei_cobre"}/>)
                method_list.push("spei_cobre")
            }
            if(payok_methods.find((p)=>p===method)){
                opt.push(<Tab><AbaTitulo className={"titulo-aba"} textOnly={true} texto={payokMethods[method].replace('payok_', '')} /></Tab>)
                pg.push(<PayokPayment setShowTermos={setShowTermos} payment_type={payokMethods[method]} />)
                method_list.push(method)
            }
            if(method === "sauripay"){
                opt.push(<Tab><AbaTitulo texto={''} src={mobile_money} alt={"Imagem da aba SauriPay"} className={"titulo-aba"} isGpay={true}/></Tab>)
                pg.push(<SauriPay setShowTermos={setShowTermos} payment_type="sauripay"/>)
                method_list.push("sauripay")
            }

        }
        
        setMethodList(method_list)
        setOpt_payment(opt)
        setPg_payment(pg)

  

    };

    useEffect(()=>{
        if(methodList.length>0){
            setCurrentMethod(methodList[0])
        }
    },[methodList])

    return (
        <div>
            <Navbar />
            <div className='tela'>
                <div className={container}>
                    <div className={containerMain}>
                        {!loadingCheckterms ?
                            <>
                                {showTermos === false ?
                                    <Tabs onSelect={(index, lastIndex, event)=>{setCurrentMethod(methodList[index])}}>
                                        <TabList>
                                            {opt_payment}
                                        </TabList>
                                        {pg_payment.map((pg, index) => {
                                            return <TabPanel>
                                                {pg_payment[index]}
                                            </TabPanel>
                                        })}
                                        {/* <TabPanel>
                                            {pg_payment[0]}
                                        </TabPanel>
                                        <TabPanel>
                                            {pg_payment[1]}
                                        </TabPanel>
                                        <TabPanel>
                                            {pg_payment[2]}
                                        </TabPanel>
                                        <TabPanel>
                                            {pg_payment[3]}
                                        </TabPanel> */}
                                    </Tabs>
                                    :
                                    <AppletTermos
                                        aceitetermos={aceitetermos}
                                        toggle={toggle}
                                        lang={lang}
                                        getStrLang={getStrLang}
                                        termos={termos}
                                        mostrarInformacoesPgto={mostrarInformacoesPgto}
                                        orderFrom={orderFromDeposit}
                                        dataLang={"op_pgt"}
                                        doc={doc}
                                        changeDoc={changeDoc}
                                        clientName={clientName}
                                        client_logo={client_logo}
                                        is_white_label={is_white_label}
                                    />
                                }
                            </>
                            :
                            <div className="centered-loading-terms-deposit">
                                <img src={Loading} alt={"loading"} width="30px" height="30px" />
                            </div>
                        }
                        {modal &&
                            <ModalTermos
                                modal={modal}
                                toggle={toggle}
                                lang={lang}
                                getStrLang={getStrLang}
                                aceitetermos={aceitetermos}
                                doc={doc}
                            />
                        }
                    </div>
                    <div className={containerSecondary}>
                        {/*<p data-lang-str="favorecid_"></p>*/}
                        <ReturnInfo currentMethod={currentMethod}/>
                    </div>
                </div>
                {currentMethod==="raspay_card_rate" && <><br/><br/><br/><br/><br/><br/></>}
                <Footer flag={client_logo}/>
            </div>
        </div>
    )
}

export default DepositScreen